// extracted by mini-css-extract-plugin
export default {"menuList":"menuList--WwYMm","menuItem":"menuItem--BvTli"};